import React from 'react';

import PropTypes from 'prop-types';

import Form from '@asteria/component-form';
import { FeatureFlag } from '@asteria/component-tools/featureflag';

import { cn } from '@asteria/utils-funcs/classes';

import Header, { HeaderSimple } from '../../components/header';

import CategoryPageContent from './content';
import { useForecastQueries } from './hooks';

import './styles.scss';

const CategoryPage = React.memo((props) => {
	const { className, onAction, onSubmit, variant } = props;

	const [view, setView] = React.useState('graph');
	const path = location.pathname;
	const tag = path?.split('/')?.[3];

	const { form, query, hasTransactions } = useForecastQueries({
		variant: [view, tag].filter(Boolean).join('-'),
		onSubmit,
	});

	const onChangeView = React.useCallback((view) => {
		return () => {
			setView(view);
		};
	}, []);

	const onGetInitialValues = React.useCallback(() => {
		return form;
	}, [form]);

	return (
		<div
			className={cn(
				'asteria-component__forecaster-page',
				'asteria--type-category',
				{ [`asteria--view-${view}`]: view },
				className,
			)}
		>
			<Form values={form}>
				<FeatureFlag feature="forecaster-header-outside">
					<HeaderSimple onAction={onAction} onSubmit={onSubmit} />
				</FeatureFlag>

				<FeatureFlag feature="forecaster-header-outside" invert>
					<Header onAction={onAction} onSubmit={onSubmit} />
				</FeatureFlag>
				<CategoryPageContent
					onAction={onAction}
					onSubmit={onSubmit}
					loading={
						(query?.isFetching &&
							!form?.deposit &&
							!form?.withdraw) ||
						(!hasTransactions && view === 'transactions')
					}
					variant={variant}
					onChangeView={onChangeView}
					view={view}
					// onReset={reset}
					onGetInitialValues={onGetInitialValues}
				/>
			</Form>
		</div>
	);
});

CategoryPage.displayName = 'CategoryPage';

CategoryPage.propTypes = {
	className: PropTypes.string,
	onAction: PropTypes.func,
	onSubmit: PropTypes.func,
	variant: PropTypes.string,
};

export default CategoryPage;
